import persistedState from 'vuex-persistedstate'
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		userinfo: '',
		token: '',
		tokenFlag: false,
		selectUsers:[],
		selectTags:[],

	},
	mutations: {
		setUserinfo(state, data) {
	        state.userinfo = data
	   	},
		setToken(state,data){
			state.token = data
		},
		setTokenFlag(state, data) {
			state.tokenFlag = data
		},
		selectTags(state,data){
			state.selectTags = data;
		},
		selectUsers(state,data){
			state.selectUsers = data;
		}
	},
	actions: {
		setUserinfo({commit},data){
			commit('setUserinfo',data)
		},
		setToken({commit},data){
			commit('setToken',data)
		},
		// setTokenNewLogin({commit}, data) {
		// 	commit('setTokenFlag', data)
		// }
	},
	plugins: [
		persistedState({
			storage: window.localStorage,
			reducer(val) {
				return {
					userinfo: val.userinfo,
					token: val.token
				}
			}
		})
	]
})
